import { z } from 'zod';

/**
 * Catégories d'entretien suivies (docs/DECISIONS.md). Liste produit commune à tous les garages ;
 * extensible par garage plus tard. Les libellés sont des textes d'interface.
 */
export const MAINTENANCE_CATEGORIES = [
  'oil_change',
  'filters',
  'brake_fluid',
  'coolant',
  'brake_pads',
  'brake_discs',
  'tyres',
  'timing',
  'battery',
  'spark_plugs',
  'clutch',
  'gearbox_oil',
  'other',
] as const;

export const MaintenanceCategory = z.enum(MAINTENANCE_CATEGORIES);
export type MaintenanceCategory = z.infer<typeof MaintenanceCategory>;

export const MAINTENANCE_LABELS: Record<MaintenanceCategory, string> = {
  oil_change: 'Vidange',
  filters: 'Filtres',
  brake_fluid: 'Liquide de frein',
  coolant: 'Liquide de refroidissement',
  brake_pads: 'Plaquettes',
  brake_discs: 'Disques',
  tyres: 'Pneus',
  timing: 'Distribution',
  battery: 'Batterie',
  spark_plugs: 'Bougies',
  clutch: 'Embrayage',
  gearbox_oil: 'Huile de boîte',
  other: 'Autre',
};
